import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: () => import('@/views/login.vue') },
    { path: '/index', component: () => import('@/views/index.vue') },
    { path: '/app-config', component: () => import('@/views/appConfig.vue') },
    { path: '/token-log', component: () => import('@/views/tokenLog.vue') }
  ]
})